<template>
  <div class="course-grid-slider" uk-slider="finite: true">
    <home-section-header
      :title="displayTitle"
      icon="uil-notebooks"
      :to="collectionRoute"
      show-slider-navigation
    />
    <ul id="book-popular"
        class="uk-slider-items uk-child-width-1-3@m uk-child-width-1-2@s uk-child-width-1-2 uk-grid-small uk-grid">
      <li v-for="(collection, index) in collections" :key="'collection_index_' + index">
        <router-link :to="{ name: 'user.collection-detail', params: { id: collection.id } }">
          <!-- Desktop Card -->
          <div class="book-popular-card desktop-card">
            <img :alt="collection.name" :src="collection.cover_image_link" class="cover-img">
            <div class="book-details">
              <h3 class="book-title">{{ collection.name }}</h3>
              <p class="book-author"><i class="icon-feather-star"></i> {{ collection.user.name }} {{ collection.user.surname }}</p>
              <p class="created-date"><i class="uil-calendar-alt"></i> {{ formatDate(collection.created_at) }}</p>
            </div>
          </div>
          <!-- Mobile Card -->
          <div class="collection-card-mobile mobile-card">
            <div class="collection-card-image">
              <img :alt="collection.name" :src="collection.cover_image_link">
            </div>
            <div class="collection-card-content">
              <h5>{{ collection.name }}</h5>
              <p><i class="icon-feather-star"></i> {{ collection.user.name }} {{ collection.user.surname }}</p>
              <p class="created-date"><i class="uil-calendar-alt"></i> {{ formatDate(collection.created_at) }}</p>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
    <hr>
  </div>
</template>

<script>
import moment from "moment";
import { MOMENT_DATE_FORMAT_FOR_KT } from "@/core/config/constant";
import HomeSectionHeader from "@/view/components/section/HomeSectionHeader.vue";

export default {
  name: "CollectionCardSlider",
  components: {
    HomeSectionHeader
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    collections: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    collectionRoute() {
      return { name: 'user.my-collection', query: { tab: 'all_collections' } };
    },
    // type_lang backend tarafından aktif dile göre çevrilmiş olarak gelir
    displayTitle() {
      return this.getLocalizedWidgetTitle(this.item, this.$t("home.My_collections"));
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      return moment(date).format(MOMENT_DATE_FORMAT_FOR_KT);
    }
  }
};
</script>

<style scoped>
/* Desktop Card — tıklanabilir: border yok, soft shadow */
#book-popular .desktop-card {
  display: flex !important;
  gap: 12px;
  padding: 12px !important;
  padding-right: 12px !important;
  background: #fff !important;
  border: none !important;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin: 0 0 10px !important;
  align-items: flex-start !important;
  overflow: visible !important;
  cursor: pointer;
}

#book-popular .desktop-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

#book-popular .desktop-card:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

#book-popular .desktop-card .cover-img {
  width: 80px !important;
  height: 110px !important;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
  margin-top: -24px !important;
  box-shadow: 0 3px 11px -2px rgba(0, 0, 0, 0.33) !important;
  padding: 5px !important;
  background-color: #fff !important;
}

/* Mobile Card - Hidden on Desktop */
#book-popular .mobile-card {
  display: none !important;
}

#book-popular .book-details {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column;
  min-width: 0 !important;
  padding: 0 !important;
  margin-left: 12px !important;
}

#book-popular .book-details .book-title {
  margin: 0 0 6px 0 !important;
  font-size: 14px !important;
  font-weight: 600;
  color: #333 !important;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: calc(14px * 1.4 * 2);
  height: auto !important;
}

#book-popular .book-details .book-author {
  margin: 0 0 4px 0 !important;
  font-size: 12px !important;
  color: #666 !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4 !important;
}

#book-popular .book-details .book-author i {
  color: var(--primaryColor);
  font-size: 13px;
  flex-shrink: 0;
}

/* Mobile Card Styles — tıklanabilir: border yok, soft shadow */
#book-popular .collection-card-mobile {
  background: #fff;
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin: 0 0 10px;
  display: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

#book-popular .collection-card-mobile:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

#book-popular .collection-card-image {
  width: 100%;
  height: 100px;
  overflow: hidden;
  background: #f5f5f5;
}

#book-popular .collection-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#book-popular .collection-card-content {
  padding: 10px 12px;
}

#book-popular .collection-card-content h5 {
  margin: 0 0 6px 0;
  font-size: 14px;
  font-weight: 600;
  color: #393939;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: calc(14px * 1.4 * 2);
}

#book-popular .collection-card-content p {
  margin: 0;
  font-size: 12px;
  color: #8d8d8d;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#book-popular .collection-card-content p i {
  color: var(--primaryColor);
  font-size: 12px;
}

#book-popular .collection-card-content .created-date {
  margin-top: 6px;
  font-size: 12px;
  color: #999;
}

#book-popular .collection-card-content .created-date i {
  color: #999;
  font-size: 12px;
}

#book-popular .book-details .created-date {
  margin-top: auto !important;
  margin-bottom: 0 !important;
  font-size: 12px !important;
  color: #999 !important;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1.4 !important;
}

#book-popular .book-details .created-date i {
  color: #999 !important;
  font-size: 12px;
  flex-shrink: 0;
}

/* Tablet - Show Mobile Card */
@media (max-width: 960px) {
  /* Slider grid gap */
  #book-popular.uk-grid {
    margin-left: -8px !important;
  }

  #book-popular.uk-grid > li {
    padding-left: 8px !important;
  }

  /* Switch cards */
  #book-popular .desktop-card {
    display: none !important;
  }

  #book-popular .mobile-card {
    display: block !important;
  }

  #book-popular .collection-card-mobile {
    display: block !important;
  }
}

/* Mobile */
@media (max-width: 768px) {
  #book-popular .collection-card-image {
    height: 90px;
  }

  #book-popular .collection-card-content {
    padding: 8px 10px;
  }

  #book-popular .collection-card-content h5 {
    font-size: 13px;
    line-height: 1.4;
    max-height: calc(13px * 1.4 * 2);
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  #book-popular .collection-card-mobile {
    border-radius: 14px;
  }

  #book-popular .collection-card-image {
    height: 80px;
  }

  #book-popular .collection-card-content {
    padding: 8px;
  }

  #book-popular .collection-card-content h5 {
    font-size: 12px;
    line-height: 1.4;
    max-height: calc(12px * 1.4 * 2);
    margin-bottom: 4px;
  }
}
</style>
